export default {"src":"/_next/static/image/public/images/ic_video_circle_white.62397e90723d24d45a5f3a640eee9441.svg","height":32,"width":32};